import React, { useEffect, useState } from "react";
import "./Notices.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const M_MONTHS = ["जाने", "फेब्रु", "मार्च", "एप्रिल", "मे", "जून", "जुलै", "ऑग", "सप्टें", "ऑक्टो", "नोव्हें", "डिसें"];
const DEV = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
const toDev = (n) => String(n).replace(/\d/g, (d) => DEV[d]);
const PALETTE = [
  { color: "#0F5C2E", tint: "#E8F3EA" },
  { color: "#1466A8", tint: "#E7F0F8" },
  { color: "#C06A12", tint: "#FBF0E0" },
  { color: "#B23A55", tint: "#F8E9EC" },
];

const Notices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const res = await fetch(`${API}/api/notices`);
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        const sorted = (Array.isArray(data) ? data : []).sort((a, b) =>
          a.isImportant === b.isImportant
            ? new Date(b.createdAt) - new Date(a.createdAt)
            : b.isImportant - a.isImportant
        );
        setNotices(sorted);
      } catch {
        setError("सूचना लोड करता आल्या नाहीत");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <section className="rk-hero">
        <div className="rk-hero-inner">
          <div className="rk-crumb">मुख्यपृष्ठ / सूचना</div>
          <h1 className="rk-hero-title">सूचना फलक</h1>
          <p className="rk-hero-sub">ग्रामपंचायतीच्या अधिकृत सूचना, परिपत्रके व घोषणा येथे प्रसिद्ध केल्या जातात.</p>
        </div>
      </section>

      <section className="rk-wrap" style={{ paddingTop: 44, paddingBottom: 20 }}>
        {loading ? (
          <p className="rk-loading">सूचना लोड होत आहेत...</p>
        ) : error ? (
          <p className="rk-error">⚠️ {error}</p>
        ) : notices.length === 0 ? (
          <p className="rk-empty">कोणत्याही सूचना उपलब्ध नाहीत</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {notices.map((n, i) => {
              const d = n.createdAt ? new Date(n.createdAt) : new Date();
              const pal = PALETTE[i % PALETTE.length];
              const tag = n.isImportant ? "महत्त्वाचे" : "सूचना";
              const isImg = n.attachment && /\.(jpg|jpeg|png|webp)$/i.test(n.attachment);
              return (
                <div key={n._id} className="rk-notice-item" style={{ borderLeft: `5px solid ${pal.color}` }}>
                  <div className="rk-notice-date">
                    <div className="rk-notice-day">{toDev(String(d.getDate()).padStart(2, "0"))}</div>
                    <div className="rk-notice-mon">{M_MONTHS[d.getMonth()]}</div>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 9, flexWrap: "wrap" }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: pal.color, background: pal.tint, padding: "3px 11px", borderRadius: 100 }}>{tag}</span>
                      {i < 2 && <span style={{ fontSize: 11.5, fontWeight: 700, color: "#fff", background: "#E8871E", padding: "3px 10px", borderRadius: 100 }}>नवीन</span>}
                      <span style={{ fontSize: 13, color: "#8a9990" }}>{d.toLocaleDateString("en-GB")}</span>
                    </div>
                    <div style={{ fontWeight: 600, fontSize: 17.5, marginTop: 7, color: "#17241C", lineHeight: 1.4 }}>{n.title}</div>
                    {n.description && <div style={{ fontSize: 14.5, color: "#5B6B60", marginTop: 6, lineHeight: 1.55 }}>{n.description}</div>}
                    {isImg && <img src={n.attachment} alt={n.title} loading="lazy" style={{ marginTop: 12, maxWidth: "100%", borderRadius: 10, border: "1px solid #E3EAE1" }} />}
                  </div>
                  {n.attachment && !isImg && (
                    <a href={n.attachment} target="_blank" rel="noopener noreferrer" className="rk-soft-btn" style={{ flexShrink: 0, textDecoration: "none" }}>📄 वाचा</a>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default Notices;
